import styled from "styled-components";
import { Button } from "components/Button";

export const ReportsContent = styled.div`
  .title {
    font-weight: 700;
    font-size: 16px !important;
  }

  .value {
    font-size: 14px !important;
    font-weight: 400;
    color: #364863 !important;
  }

  .space {
    margin-right: 20px;
  }

  /* Zera o mb-3 do BackButton pois o Title controla o gap de 25px (Figma) */
  .back-button {
    margin-bottom: 0 !important;
  }
`;

export const Title = styled.p`
  color: #364863;
  font-family: 'Lato', sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 28px;
  /* 25px (Figma) - 4px do py-1 do BackButton = 21px */
  margin: 21px 0 16px 0;
`;

export const SubTitle = styled.p`
  color: #364863;
  font-size: 16px;
  margin-top: 30px;
  font-weight: 700;
`;

export const DateFilter = styled.div`
  width: 100%;
  height: 90px;
  padding: 20px;
  margin-top: 30px;
  border-radius: 10px;
  background-color: #0E4C54;


  display: flex;
  align-items: center;
  flex-direction: row;

  input {
    background-color: #ffffff;
    margin-right: 20px;
    width: 154px;
  }
`;

export const DateLabel = styled.p`
  color: #FFFFFF;
  font-size: 12px;
  font-weight: 400;
  margin-right: 20px;
`;


export const FilterButton = styled(Button).attrs({
  className: "button bg-cyanLightViveo w-sm-70 w-md-40 w-40 filter-button",
  height: 40,
  width: 85
})`
  margin-right: 20px;
`;

export const CleanFilters = styled.p`
  text-decoration: underline;
  color: #ffffff;
  font-size: 12px;
  cursor: pointer;
`;

export const IndicatorArea = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  justify-content: flex-start;
`;

export const CategoryArea = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;
  justify-content: flex-start;
`;